module.exports = __webpack_public_path__ + "static/christian-89dbff48b746d8b845603dce21605ee5.png";